var path_list =[
  // 产品绑定页
  '/pages/itocare',
  // 我的
  // '/account',
  '/pages/my-product',
  // '/pages/ito-care',
  // '/pages/itocare-apply'
]